'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartEntityHeader } from './cart-entity-header.component';

import { CartItem } from '@/types/cart.types';
import { getCartItemEntity } from '@/utils/cart/get-cart-item-entity.util';

interface CartItemHeaderProps {
  item: CartItem;
  dataTestId?: string;
}

export function CartItemHeader({
  item,
  dataTestId = DataTestIdEnum.CART_ITEM_PROFESSIONAL,
}: CartItemHeaderProps) {
  const { name, avatar, type } = getCartItemEntity(item);

  return (
    <CartEntityHeader
      name={name}
      avatar={avatar}
      entityType={type}
      dataTestId={dataTestId}
    />
  );
}
